export default __webpack_public_path__ + "static/media/SOBRE_NOSOTROS_1-569x307.4b42ba62.webp";